import { Button, Modal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

interface ModalFooterProps {
  isButtonDisabled?: boolean
  isProcessing?: boolean
  onSubmit?: () => void
}

export const ModalFooter = ({ isButtonDisabled, onSubmit, isProcessing }: ModalFooterProps): ReactElement => {
  const { t } = useTranslation()

  const handleSubmitButtonClick = useCallback(() => {
    onSubmit?.()
  }, [onSubmit])

  return (
    <Modal.Footer>
      <Button type="button" onClick={handleSubmitButtonClick} disabled={isButtonDisabled} loading={isProcessing}>
        {t('transfer_ownership_modal.submit')}
      </Button>
    </Modal.Footer>
  )
}
